
import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IDeductionComponent, IDeductionComponentSearch } from "../models/DeductionComponent";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';


import { currentUserSessionAtom } from 'library/store';
//import { IPolicyRisk, IPolicyRiskCoverage } from 'features/deductionComponention/models/Policy';


const _ = () => {

    const axios = useAxios(); 

    const createDeductionComponent = async (deductionComponent: IDeductionComponent)  =>       
        await (await axios.post('/api/setup/deductionComponent/create', deductionComponent)).data;       
        
    const updateDeductionComponent = async (deductionComponent: IDeductionComponent)  =>       
        await (await axios.post('/api/setup/deductionComponent/update', deductionComponent)).data; 
    
    const getDeductionComponent = async (id  : number )  => {
      const {data} = (await axios.get(`/api/setup/deductionComponent/get-deductionComponent/${id}`));
      return await data;
    }
   

    const getDeductionComponents = async (criteria: IDeductionComponentSearch, pagination?: IPagination) : Promise<IDeductionComponent[]> => {

      const {name, description} = criteria;
      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/setup/deductionComponent/get-deductionComponents?name=${name}&description=${description}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }

    const getAllDeductionComponents = async () : Promise<IDeductionComponent[]> => {

      const {data} = (await axios.get(`/api/setup/deductionComponent/get-all-deductionComponents`));
      return await data;
    }
    
   
    return {    
      createDeductionComponent,
      updateDeductionComponent,
      getDeductionComponent,
      getDeductionComponents,

      getAllDeductionComponents

      
    } 
}

export default _;

export interface IFilterDeductionComponentOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [string[], React.Dispatch<React.SetStateAction<string[]>>],
  stateFiltered?: [IDeductionComponent[], React.Dispatch<React.SetStateAction<IDeductionComponent[]>>],
}

const defaultFilterDeductionComponentOption: IFilterDeductionComponentOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterDeductionComponent = (  type: number, onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IDeductionComponent) => void,
                                            filterOption?: IFilterDeductionComponentOption  ) => {

  const { getDeductionComponents } = _();

  const { t, i18n } = useTranslation();   
  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterDeductionComponentOption;



  const [headDeductionComponentCells, setHeadDeductionComponentCells]  = useState<HeadCell<IDeductionComponent>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', },
    
    {id:'name', label : t('Name'),  display: true, type: 'string', },
    {id:'description', label : t('Description'),  display: true, type: 'string', },
    {id:'isActive', label : t('Active ?'),  display: true, type: 'boolean', },
    

  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [
    
      {name: 'name', text: t('Name'), value: ''},
      {name: 'description', text: t('Description'), value: ''}
     
    ]);    

  const [filteredDeductionComponents, ] = useState<IDeductionComponent[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IDeductionComponent[]> => {
   
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
   
    const arr = await getDeductionComponents( { name,description}, pagination );
    
    return arr;
  }

  const objKey: keyof IDeductionComponent = 'id';

  return {
    title: t('DeductionComponent'), headCells: headDeductionComponentCells, objKey,
    filterElements, rows: filteredDeductionComponents, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
